import { useGLTF } from '@react-three/drei';
import { useRef, useMemo } from 'react';
import { Mesh, CapsuleGeometry, SphereGeometry, MeshStandardMaterial } from 'three';

export function Pedestrians() {
  const pedestriansRef = useRef < Mesh > (null);
  const { scene } = useGLTF("/models/pedestrian.glb");

  const pedestrianPositions = useMemo(() => [
    [-25, 13], [-5, 13], [15, 13], [35, 13],
    [-35, -13], [-15, -13], [5, -13], [25, -13]
  ], []);

  return (
    <group>
      {pedestrianPositions.map(([x, z], i) => {
        let rotationY = z > 0 ? Math.PI / 2 : -Math.PI / 2;

        // Özel pozisyonlar için dönüş açılarını güncelle
        if (x === -5 && z === 13) rotationY = Math.PI;
        if (x === 5 && z === -13) rotationY = 0;

        return (
          <primitive
            key={i}
            object={scene.clone()}
            position={[x, 1.78, z]}
            scale={[2, 2, 2]}
            rotation={[0, rotationY, 0]}
            castShadow
          />
        );
      })}
    </group>
  );
}